import { MenuItem, Select, Box, Typography } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { useLanguage } from '../../../../utils/i18n';
import useHeaderTheme from 'hooks/useHeaderTheme';

export default function LanguageSelector({ sx }) {
  const { language, changeLanguage } = useLanguage();
  const { iconColor, hoverColor } = useHeaderTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        bgcolor: 'transparent',
        borderRadius: 2,
        px: 1.2,
        py: 0.5,
        '&:hover': { bgcolor: hoverColor },
        transition: 'background-color 0.2s',
        ...sx
      }}
    >
      <LanguageIcon sx={{ color: iconColor, mr: 1 }} />

      <Select
        value={language}
        onChange={(e) => changeLanguage(e.target.value)}
        variant="standard"
        disableUnderline
        sx={{
          minWidth: 80,
          fontWeight: 500,
          color: iconColor,
          '& .MuiSelect-icon': { color: iconColor },
          '& .MuiSelect-select': {
            py: 0.5,
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }
        }}
      >
        <MenuItem value="en" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2">English</Typography>
        </MenuItem>
        <MenuItem value="id" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2">Indonesian</Typography>
        </MenuItem>
        <MenuItem value="zh" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2">Chinese (中文)</Typography>
        </MenuItem>
      </Select>
    </Box>
  );
}
